import styled from "styled-components"

const Wrap = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 30px;
`;
export default function TableFooter({children, ...props}) {

    return (
        <Wrap {...props}>
            {children}
        </Wrap>
    )
}